module.exports = __webpack_public_path__ + "img/chevron-down.a6673220.svg";